import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { ARService } from '../../ar.service';
import { dataARTransactionItem, enumValidValueItem } from '../../_models/ar.models';

@Component({
  standalone: false,
  selector: 'app-ar-insurance-claims',
  templateUrl: './ar-insurance-claims.component.html',
  styleUrls: ['./ar-insurance-claims.component.css']
})
export class ArInsuranceClaimsComponent implements OnInit {

  LOCID: number;
  CaseWorkItemId: string = '';
  PatientId: string = 'F0F6903F-F29E-E711-A59F-6045CB81D461';
  PatientCaseId: string = '9CAC7A96-548E-EA11-A62B-6045CB81D461';
  DoctorId: string = 'CD8EF4FE-B36C-E711-ADF2-005056BE0009';

  isLoading: boolean = false;
  dataTransactionItems: dataARTransactionItem[] = [];

  enumCoverageTypePercent: string = '00000048-1000-0000-0000-000000000001';
  enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';

  enumStatusList: enumValidValueItem[] = [];

  constructor(
    private arService: ARService,
    private changeRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.init();

  }

  async init() {

    let promises: any[] = [
      this.getPatientClaims(this.PatientId),
      this.getEnumClaimStatusItems(),
    ];

    this.isLoading = true;

    try {
      let results: any[] = await Promise.all(promises);
      this.dataTransactionItems = results[0];

      var claims = [];
      this.dataTransactionItems.forEach(trainsactionItem => {
        trainsactionItem.dataARClaims.forEach(claim => {
          var newObj = JSON.parse(JSON.stringify(trainsactionItem));
          newObj.dataARClaims = [];
          newObj.DATA_CLAIM = claim;
          claims.push(newObj);
        })
      });

      this.dataTransactionItems = claims;
      this.enumStatusList = results[1];

    } catch (err) {
      console.log(err);
    }

    this.isLoading = false;
    this.changeRef.detectChanges();
  }

  getEnumStatus(transactionItem) {
    var enumValidValue = this.enumStatusList.find(validValueItem => {
      return transactionItem.DATA_CLAIM.enumClaimStatusID === validValueItem.ValidValueItemId;
    });

    return enumValidValue.ItemDisplayValue;
  }

  calculateCost(transactionItem: any, billTo: string) {

    var doctorFee: number = transactionItem.Price;
    var insuranceCoverage: number;

    if (transactionItem.enumFeeCoverageCalcTypeId === this.enumCoverageTypeAmount) {
      insuranceCoverage = transactionItem.CoverageAmount;
    } else {
      insuranceCoverage = (doctorFee * (transactionItem.CoveragePCT / 100));
    }

    if (billTo === 'insurance') {
      return insuranceCoverage;
    } else {

      var billableToPatient = doctorFee - insuranceCoverage;
      if (billableToPatient < 0) {
        return 0;
      }

      return billableToPatient;
    }
  }

  getEnumClaimStatusItems() {
    return this.arService.getEnumValidValueItemsByValidValueName("enumClaimStatus").toPromise();
  }

  getPatientClaims(PatientId: string) {
    return this.arService.getPatientClaims(PatientId).toPromise();
  }
}
